export default [
	// 质检接驳列表
	{
		path: 'quality_handover',
		name: 'm_quality_handover',
		meta: {
			templateManage: {
				workType: 4,
				export: 'b_quality_handover_exporttemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/quality/handover_list')
	},
	// 质检列表
	{
		path: 'quality_list',
		name: 'm_quality_list',
		meta: {
			templateManage: {
				workType: 7,
				export: 'b_quality_list_export'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/quality/quality_list')
	},
	// 质检报告编辑
	{
		path: 'quality_report_edit',
		name: 'm_quality_report_edit',
		meta: {
			authFree: true
		},
		props: route => route.params,
		component: () => import('@/pages/quality/quality_report_edit')
	},
	// 质检报告列表已合并至质检列表（quality_list），本路由不再注册
];
